import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadRestaurantMenuList() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_MENU_LIST, function* (action) {
    try {
      const response = yield API.loadRestaurantMenuList(
        action.id,
        action.orderType,
        action.all,
        action.data
      );
      if (response.data.success) {
        yield put(actions.loadRestaurantMenuListSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load restaurant menu. \n" + response.data.message
        );
        yield put(actions.loadRestaurantMenuListFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load restaurant menu. \n")
      );
      yield put(actions.loadRestaurantMenuListFail());
    }
  });
}

/////////* New Menu Loading Method START *//////////
export function* loadRestaurantMenuCategory() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_MENU_CATEGORY, function* (
    action
  ) {
    try {
      const response = yield API.loadRestaurantMenuCategory(
        action.id,
        action.orderType
      );
      if (response.data.success) {
        yield put(
          actions.loadRestaurantMenuCategorySuccess(response.data.data)
        );
      } else {
        alert(
          "Warning: Fail to load restaurant menu category. \n" +
            response.data.message
        );
        yield put(actions.loadRestaurantMenuCategoryFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(
          error,
          "Fail to load restaurant menu category. \n"
        )
      );
      yield put(actions.loadRestaurantMenuCategoryFail());
    }
  });
}

export function* loadRestaurantMenuCategoryItems() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS, function* (
    action
  ) {
    try {
      const response = yield API.loadRestaurantMenuCategoryItems(
        action.id,
        action.orderType,
        { category: action.category }
      );
      if (response.data.success) {
        yield put(
          actions.loadRestaurantMenuCategoryItemsSuccess({
            index: action.index,
            data: response.data.data,
          })
        );
      } else {
        alert(
          "Warning: Fail to load restaurant menu category items. \n" +
            response.data.message
        );
        yield put(actions.loadRestaurantMenuCategoryItemsFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(
          error,
          "Fail to load restaurant menu category items. \n"
        )
      );
      yield put(actions.loadRestaurantMenuCategoryItemsFail());
    }
  });
}
/////////*  New Menu Loading Method END  *//////////

export function* loadRestaurantMenuDetail() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_MENU_DETAIL, function* (action) {
    try {
      const response = yield API.loadRestaurantMenuDetail(action.id);
      if (response.data.success) {
        yield put(actions.loadRestaurantMenuDetailSuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load restaurant menu detail. \n" +
            response.data.message
        );
        yield put(actions.loadRestaurantMenuDetailFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to load restaurant menu detail. \n")
      );
      yield put(actions.loadRestaurantMenuDetailFail());
    }
  });
}

export default function* menuSaga() {
  yield all([
    fork(loadRestaurantMenuList),
    fork(loadRestaurantMenuCategory),
    fork(loadRestaurantMenuCategoryItems),
    fork(loadRestaurantMenuDetail),
  ]);
}
